import OfferRevaluate from './OfferRevaluate';

export default OfferRevaluate;
